import {
  ApiResponse,
  AdSupplier,
  AdSupplierUser,
  PaginationResponse,
  User,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseAdSupplierUsersParams {
  page?: number
  pageSize?: number
  supplier_id?: number
  account?: string
}

export function useAdSupplierUsers({
  page = 1,
  pageSize = 10,
  supplier_id,
  account,
}: UseAdSupplierUsersParams = {}) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (supplier_id) params.supplier_id = supplier_id
  if (account) params.account = account

  const { data, error, mutate } = useGet<
    ApiResponse<PaginationResponse<AdSupplierUser & { user: User; supplier: AdSupplier }>>
  >(
    token ? '/api/ad-supplier-users' : null,
    params,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    users: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function useAdSupplierUser(id: number | null) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<
    ApiResponse<AdSupplierUser & { user: User; supplier: AdSupplier }>
  >(token && id ? `/api/ad-supplier-users/${id}` : null, undefined, token ?? '')

  return {
    adSupplierUser: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
